import { render, staticRenderFns } from "./regex-group-form.vue?vue&type=template&id=833a65be&"
import script from "./regex-group-form.vue?vue&type=script&lang=js&"
export * from "./regex-group-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports